import { contactsMsg, t } from '../../../../common/i18n/index.js';
import { OFFieldApi } from '../../../../generated/api/oFFieldApi.js';
import { not } from '../../OpenForm.js';
import { OpenFormGridCol, OpenFormGridRow } from '../../OpenFormComponents/OpenFormGrid.js';
import { OpenFormItem } from '../../OpenFormComponents/OpenFormItem.js';
import { type OpenFormSummary } from '../../OpenFormHooks/useOpenFormSummary.js';

export const OpenFormSummaryOtherContacts = ({ summary: { contactEntries } }: { summary: OpenFormSummary }) => {
  const contacts = contactEntries.filter(([question]) => not(OFFieldApi.Ordering_Contact__c)(question));
  return !contacts?.length ? null : (
    <OpenFormGridRow>
      <OpenFormGridCol colWidth={9}>
        <h4>{t.WA1M(contactsMsg)}</h4>
        <OpenFormGridRow justifyCenter={false} className="of-openform__view__summary__other-contacts">
          {contacts.map(([question, contact]) => (
            <OpenFormGridCol colWidth={4} key={question.guid + contact.Id}>
              <OpenFormItem title={question.label}>
                <div>
                  {contact.FirstName} {contact.LastName}
                </div>
                <div>{contact.Email}</div>
                <div>{contact.MobilePhone}</div>
              </OpenFormItem>
            </OpenFormGridCol>
          ))}
        </OpenFormGridRow>
        <hr />
      </OpenFormGridCol>
    </OpenFormGridRow>
  );
};
